module.exports = __webpack_public_path__ + "img/402.d359efcc.svg";